import type { FilterExtraFieldReturn } from './filter-extra-field.hook'

import { useFilterExtraField } from './filter-extra-field.hook'

interface FilterActivationTypeOptions {
  initial: string[]
}

export const useFilterActivationType = ({ initial }: FilterActivationTypeOptions): FilterExtraFieldReturn => {
  return useFilterExtraField({ name: 'activation_type', initial })
}
